import "./SingleCourse.module.css";
import Header from "@/reusable_sections/Header";
import VisualImpactExcellence from "./sections/VisualImpactExcellence";
import CourseDetails from "./sections/CourseDetails";
import RelatedCourses from "./sections/RelatedCourses";
import Footer from "@/reusable_sections/Footer";
export default function SingleCoursePage() {
  return <div>
      <Header />
      <VisualImpactExcellence />
      <CourseDetails />
      <RelatedCourses />
      <Footer />
    </div>;
}